import { FC, useContext, useEffect, useMemo, useState } from "react";
import { InfoContext, UIContext } from "../../../shared/contexts";
import { Form } from "antd";
import { GetRubricatedBooksListServiceResponse } from "../../../shared/interfaces/services/rubricated-books";
import ProductionService from "../../../shared/services/production";
import { InputFactory, RowSize } from "../../../shared/components";
import { RubricatedBooksTable } from "./components/RubricatedBooksTable";
import { getInputsFilter } from "./utils/inputsRubricatedBooks";
import { PageHeader } from "../../../shared/components/MainLayout/components";
import './index.css'
import dayjs from "dayjs";
interface RubricatedBooksListPageProps {
    title: string;
}

export const RubricatedBooksListPage: FC<RubricatedBooksListPageProps> = ({ title }) => {
    const { isLoading, showError, setIsLoading, setShowError } = useContext( UIContext );
    const { setTitle } = useContext(InfoContext);
    const [isLoadingFilters, setIsLoadingFilters] = useState(false);
    
    const [form] = Form.useForm()
    const [ rubricatedBooksList, setRubricatedBooksList ] = useState<GetRubricatedBooksListServiceResponse>({});

    const getRubricatedBooksList = async () => {
        setIsLoading(true);
        try {
            const filters = form.getFieldsValue()

            if (filters.year) {
                filters.year = dayjs(filters.year).format('YYYY'); 
            }
            
            if (filters.month) {
                filters.month = dayjs(filters.month).format('MM'); 
            }
            
            const response = await ProductionService.getRubricatedBooks(filters); 

            if (response.registros) {
                setRubricatedBooksList({ ...response });
            }
            
        } catch (error) {
            setShowError(true);
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 0);
        }
    }

    useEffect(() => {
        setTitle(title);
    }, [title]);

    const initialStateFilters = useMemo(() => ({
        year: undefined,
        month: undefined,
        fortnight: undefined
    }), []);

    const cleanFilter = () => {
        getRubricatedBooksList();
    }


    return (
        <>
            <PageHeader actions={undefined} />
            <RowSize rowProps={{ gutter: [0, 0] }} className="rubricated-books__filter-row">
                {<InputFactory 
                    form={form}
                    items={ getInputsFilter() }
                    onFilter={ getRubricatedBooksList }
                    isLoading={ isLoadingFilters }
                    initialState={ initialStateFilters }
                    onClear={cleanFilter}
                />}
            </RowSize>
            <RubricatedBooksTable
                rubricatedBooksList={rubricatedBooksList}
                isLoading={isLoading}
            />
        </>
    );
}